import React, { FC } from 'react';
import { ProductProviders } from 'src/components/pages/integrationSettings/providerConfiguration/providerElements';
import { PrintfulIntegrationDialog } from 'src/components/pages/integrationSettings/providerConfiguration/providers/printfulIntegrationWizard';
import { CustomCatIntegrationDialog } from 'src/components/pages/integrationSettings/providerConfiguration/providers/customCatIntegrationWizard';
import { PrinteersIntegrationDialog } from 'src/components/pages/integrationSettings/providerConfiguration/providers/printeersIntegrationWizard';

interface ProviderSetupDialogProps {
    providerId: number;
    providerName: string;
    onClose: () => void;
    onIntegrated: () => void;
    onConnected?: () => void;
}

export const ProviderSetupDialog: FC<ProviderSetupDialogProps> = (props) => {
    if (props.providerId === ProductProviders.Printful) {
        return <PrintfulIntegrationDialog onClose={props.onClose} onIntegrated={props.onIntegrated} onConnected={props.onConnected} />;
    }

    if (props.providerId === ProductProviders.CustomCat) {
        return <CustomCatIntegrationDialog onClose={props.onClose} onIntegrated={props.onIntegrated} />;
    }

    if (props.providerId === ProductProviders.Invition) {
        return <PrinteersIntegrationDialog onClose={props.onClose} onIntegrated={props.onIntegrated} />;
    }

    return null;
};
